import CommonNavBar from '../../common/navBar/CommonNavBar';

export default CommonNavBar;